export const selectIsAuthenticated = (state) => state.auth.isAuthenticated

export const selectAuthUser = (state) => state.auth.user

export const selectWebsites = (state) => state.auth.websites

export const selectAssets = (state) => state.auth.assets

export const selectIsMfaRequired = (state) => state.auth.isMfaRequired

export const selectOtpToken = (state) => state.auth.otpToken

export const selectOtpEmail = (state) => state.auth.otpEmail
